export default __webpack_public_path__ + "media/images/brighteon-social/Icon-Follower-Gray-b4a229685cf483210f136f9a0dacd875.svg";